import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const RelationshipCategoriesModelSchema = z
  .object({
    id: z.string(),
    // cfg.contact_relationship_titles.type_id / name are NOT NULL (20261013120000)
    relationship_type_id: z.string(),
    category: z.string()
  })
  .strict()

export const RelationshipCategoriesModelFields = makeFieldKeys(RelationshipCategoriesModelSchema)

export type RelationshipCategoriesModel = z.infer<typeof RelationshipCategoriesModelSchema>

function validateRelationshipCategoriesModel(data: unknown): RelationshipCategoriesModel {
  try {
    return validateWithZodSchema(RelationshipCategoriesModelSchema, data, 'relationship categories model')
  } catch (error) {
    throw new Error(`Relationship categories model validation failed: ${error}`)
  }
}
